import React, { Component } from 'react';
import { Modal, Form, Row, Col, Button, Tabs, Table, Tooltip, DatePicker } from "antd";

import MensalidadesPage from "./MensalidadesPage";
import EmpresasPage from "./EmpresasPage";
import EmitentesPage from "./EmitentesPage";
import ParametrosNFeCFOPPage from "./ParametrosNFeCFOPPage";
import EmpresaConfigForm from '../components/EmpresaConfigForm';
import UsuariosPage from "./UsuariosPage";
import GruposUsuariosPage from "./GruposUsuariosPage";
import PermissoesPage from "./PermissoesPage";
import AlterarSenhaPage from "./AlterarSenhaPage";
import ParametrosDrawer from "../components/ParametrosForm";
import ParametrosCobrancasForm from "../components/ParametrosCobrancasForm";
import ParametrosNFeForm from "../components/ParametrosNFeForm";

import { getUsuario, getTemPermissao } from "../utils/LoginManager";

const { Item: ItemForm } = Form;
const TabPane = Tabs.TabPane;
const { Column } = Table;


export default class extends Component {
    state = {

        activeKey: "mensalidades",

    }


    componentDidMount() {
        const usuario = getUsuario();
        this.setState({
            usuario,
            activeKey: usuario && usuario.emp_codigo === 2 ? 'empresa' : 'mensalidades'
        });
    }

    onChangeTabs = (activeKey) => {
        this.setState({ activeKey });
    }


    render() {
        const { } = this.state;

        return (
            <div className="contentRoutesContainer">

                <span className="tituloPage">Configurações do Sistema</span>
                <div className="divider-page" />

                <Tabs
                    type="line"
                    activeKey={this.state.activeKey}
                    onChange={this.onChangeTabs}
                >
                    {this.state.usuario && this.state.usuario.emp_codigo === 2 ? null : (
                        <TabPane tab="Mensalidades" key="mensalidades">
                            <MensalidadesPage />
                        </TabPane>
                    )}
                    <TabPane tab="Empresa" key="empresa">
                        {this.state.usuario && this.state.usuario.usu_tipo === 0 ? (
                            <EmpresasPage />
                        ) : (
                            <EmpresaConfigForm />
                        )}
                    </TabPane>
                    <TabPane tab="Usuários" key="usuarios">
                        <UsuariosPage />
                    </TabPane>
                    {getTemPermissao('GruposUsuariosPage', 'cons') ? (
                        <TabPane tab="Grupo de Usuários" key="grupos">
                            <GruposUsuariosPage />
                        </TabPane>
                    ) : null}
                    {getTemPermissao('PermissoesPage', 'cons') ? (
                        <TabPane tab="Permissões dos Usuários" key="permissoes">
                            <PermissoesPage />
                        </TabPane>
                    ) : null}
                    {getTemPermissao('ConfiguracoesPage', 'cons') ? (
                        <TabPane tab="Parâmetros Gerais" key="configuracoes">
                            <ParametrosDrawer />
                        </TabPane>
                    ) : null}
                    {getTemPermissao('ParametrosCobrancasForm', 'cons') ? (
                        <TabPane tab="Cobranças" key="cobrancas">
                            <ParametrosCobrancasForm />
                        </TabPane>
                    ) : null}
                    {getTemPermissao('EmitentesPage', 'cons') ? (
                        <TabPane tab="NFe Emitentes" key="emitentes">
                            <EmitentesPage />
                        </TabPane>
                    ) : null}
                    {getTemPermissao('ParametrosNFeForm', 'cons') ? (
                        <TabPane tab="NFe Tributação" key="tributacao">
                            <ParametrosNFeForm />
                        </TabPane>
                    ) : null}
                    {getTemPermissao('ParametrosNFeCFOPPage', 'cons') ? (
                        <TabPane tab="NFe CFOPs" key="cfop">
                            <ParametrosNFeCFOPPage />
                        </TabPane>
                    ) : null}
                    <TabPane tab="Alterar Senha" key="senha">
                        <AlterarSenhaPage />
                    </TabPane>
                </Tabs>

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/ConfiguracoesPage.js